import { createStore, compose, applyMiddleware } from "redux";
import "./reduxObservableConfig";
import createReducer from "./reducers";
import createMiddleware from "./middleware";
import { throttle } from "lodash";
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
function loadState() {
    try {
        const serializedState = localStorage.getItem("stateCache");
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    }
    catch (err) {
        return undefined;
    }
}
function saveState(state) {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem("stateCache", serializedState);
    }
    catch (err) {
    }
}
function buildStore(ducks, stomp) {
    const persistedState = loadState();
    const reducers = createReducer(ducks);
    const middleware = composeEnhancers(applyMiddleware(createMiddleware(ducks, stomp)));
    const store = createStore(reducers, persistedState, middleware);
    let prevUserConfig = {};
    let prevSettings = {};
    let prevCards = {};
    let prevSelected = "";
    store.subscribe(throttle(() => {
        const ebro = store.getState().ebro || { userConfigEvents: undefined };
        const { userConfigEvents } = ebro;
        const scenarios = store.getState().scenarios || {
            selected: "",
            scenarioName: "",
            workspaceName: "",
        };
        const { selected, scenarioName, workspaceName } = scenarios;
        const settings = store.getState().settings;
        const cards = store.getState().cards;
        const stateSnapShot = {
            ebro: {
                userConfigEvents,
            },
            scenarios: {
                selected,
                scenarioName,
                workspaceName,
            },
            settings,
            cards,
        };
        if ((prevUserConfig !== undefined && prevUserConfig !== userConfigEvents) ||
            settings !== prevSettings ||
            selected !== prevSelected ||
            cards !== prevCards) {
            saveState(stateSnapShot);
            console.log("cache updated");
            prevUserConfig = userConfigEvents;
            prevSettings = settings;
            prevCards = cards;
            prevSelected = selected;
        }
    }, 1000));
    return store;
}
export default buildStore;
//# sourceMappingURL=store.js.map